// extracted by mini-css-extract-plugin
module.exports = {"GoBack":"GoBack_GoBack__39LqY","goBackButton":"GoBack_goBackButton__cOyOb","CustomStyle":"GoBack_CustomStyle__2BxUU","Authentication":"GoBack_Authentication__2BTkU"};